<template>
    <div>
        <h1 class="h5">De IJSTIJD! Kidsclub is er voor jou!</h1>
        <h2 class="h3">Wil jij op de hoogte blijven van de gaafste schaatsactiviteiten en meedoen aan leuke acties?</h2>

        <ul class="inline-list">
            <li>Je krijgt de kans om leuke prijzen te winnen en dichtbij jóuw schaatshelden te komen… misschien mag je wel een medaille uitreiken of meerijden op een dweilmachine. Hoe cool is dat!</li>
            <li>Of je wint tickets en gaat met je familie of vriendjes naar een top schaatswedstrijd in ijsstadion Thialf, het schaatshart van de wereld.</li>
            <li>Wil je leren schaatsen? Of kun je het al goed en doe je liever vette trucjes? Bekijk dan de video’s met schaatstips of doe mee aan een clinic op de schaatsbaan in jouw buurt.</li>
            <li>Regelmatig ontvang je de IJSTIJD! Kidsclub nieuwsbrief met nog véél meer acties en prijsvragen die je niet mag missen…!</li>
        </ul>

        <hr>

        <form
            class="form"
            @submit.prevent="submit"
            :class="{'form--loading': loading}">
            <h2 class="h6">Word ook fan en meld je aan voor de IJSTIJD! Kidsclub</h2>

            <div class="grid-x grid-margin-x">
                <div class="cell">
                    <radio-field
                        v-model="register" 
                        name="register"
                        :input-value="register"
                        :options="[{value: '1', name: 'Ja, ik word lid!'}, {value: '0', name: 'Nee, dank je wel.'}]" />
                </div>

                <div class="cell">
                    <div class="btn-holder btn-holder--center">
                        <submit-field>
                            Bevestigen!
                        </submit-field>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            register: '1',
            loading: false,
        };
    },
    created() {

    },
    methods: {
        ...mapActions({
            'update': 'sportid/patch'
        }),
        submit() {
            this.loading = true;

            this.update({
                newsletter: this.register
            }).then(() => {
                this.$router.push({
                    name: 'redeem_voucher',
                    params: this.$route.params,
                    query: this.$route.query,
                });
            }, () => {
                this.$router.push({
                    name: 'redeem_voucher',
                    params: this.$route.params,
                    query: this.$route.query,
                });
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
